<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :title="$t('orgManage.orgDetails')"
    v-bind="$attrs"
    destroy-on-close
    :width="'800px'"
  >
    <div class="dialog-around h-60">
      <div class="h-full org-wrapper">
        <div class="org-create-wrapper">
          <rc-form
            ref="rcForm"
            v-bind="{ form, data: formData, formItem, showSearch: false }"
          ></rc-form>
        </div>
      </div>
    </div>

    <span slot="footer" class="text-right">
      <el-button type="primary" @click="dialogVisible = false">
        {{ $t('common.closeTxt') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import orgManageApi from "@/api/orgManage";
export default {
  name: "OrgDetails",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    orgData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        labelPosition: "top",
        gutter: 20
      },
      formData: {
        orgCode: "",
        orgName: "",
        orgType: "ORGANIZATION",
        orgShortName: "",
        parentId: "",
        parentName: "",
        sort: "",
        showName: "",
        remark: ""
      },
      formItem: [
        {
          component: "rc-input",
          label: this.$t("orgManage.orgCode"),
          placeholder: "",
          prop: "orgCode",
          span: 12,
          disabled: true
        },
        {
          component: "rc-input",
          label: this.$t("orgManage.parentOrg"),
          prop: "parentName",
          disabled: true,
          span: 12
        },
        {
          component: "rc-input",
          label: this.$t("orgManage.orgName"),
          prop: "orgName",
          placeholder: "",
          disabled: true,
          span: 12
        },
        {
          component: "rc-input",
          label: this.$t("orgManage.orgShortName"),
          prop: "orgShortName",
          disabled: true,
          placeholder: "",
          span: 12
        },
        // {
        //   component: 'slot',
        //   slotName: 'orgType',
        //   span: 12
        // },
        {
          component: "rc-select",
          label: this.$t("orgManage.orgType"),
          prop: "orgType",
          disabled: true,
          span: 12,
          options: [
            {
              label: this.$t("orgManage.organization"),
              value: "ORGANIZATION"
            }
          ]
        },
        {
          component: "rc-input-number",
          label: this.$t("public.sort"),
          prop: "sort",
          disabled: true,
          placeholder: "",
          controlsPosition: "right",
          span: 12
        },
        {
          component: "rc-input",
          label: this.$t("orgManage.orgManager"),
          prop: "showName",
          placeholder: "",
          disabled: true,
          span: 12
        },
        {
          component: "rc-input",
          label: this.$t("dictInfo.description"),
          prop: "remark",
          disabled: true,
          type: "textarea",
          rows: "3",
          maxlength: 100,
          showWordLimit: true,
          placeholder: "",
          span: 12
        }
      ]
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.dialogVisible = val;
      }
    },
    dialogVisible(val) {
      this.$emit("update:visible", val);
    }
  },
  created() {
    if (this.orgData && this.orgData.id) {
      this.getDetailsById(this.orgData.id);
    }
  },
  methods: {
    getDetailsById(id) {
      orgManageApi.getDetailsById(id, { id, widthUser: true }).then(res => {
        if (res.success) {
          this.$set(this, "formData", res.data);
          this.formData.showName = `${this.formData.user.displayName}-${this.formData.user.username}`;
        }
      });
    },
    getFormFunction() {
      return this.$refs.rcForm.getComponentFunctionMap();
    }
  }
};
</script>

<style lang="scss" scoped>
.org-create-wrapper {
  padding: 0;
  height: 100%;

  ::v-deep .router {
    &:hover {
      color: white;
    }
  }
}
</style>
